<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="订单号" name="order_number"></c-form-item>
                    <c-form-item type="input" label="用户手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="用户昵称" name="nick_name"></c-form-item>
                    <c-form-item type="datetime" label="评价时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="state" :options="stateType"></c-form-item>
                </c-form>
            </m-search>

            <c-table ref="table" code="order_evaluate_list">
                <c-table-column
                        type="selector"
                ></c-table-column>

                <c-table-column
                        label="状态"
                        name="start_state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 2" style="color:green">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 1" style="color:red">{{stateText[data.state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="订单号"
                        name="order_number"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="用户昵称"
                        name="nick_name"
                ></c-table-column>

                <c-table-column
                        label="用户手机号"
                        name="user_manage_mobilephone"
                        width="110"
                ></c-table-column>

                <c-table-column
                        label="评分"
                        name="score"
                        width="50"
                ></c-table-column>

                <c-table-column
                        label="查看数量"
                        name="view_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="点赞数量"
                        name="thumb_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="评价内容"
                        name="evaluate_comment"
                        width="180"
                ></c-table-column>

                <c-table-column
                        label="评价时间"
                        name="pj_date"
                        width="140"
                ></c-table-column>


                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
						width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="navigateTo(`/order_evaluate_detail/${data.id}`)">查看</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.state == 2" @click="disableActivity(data,1)">禁用</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.state == 1" @click="disableActivity(data,2)">启用</c-table-button>
                        <c-table-button  @click="del(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_order_evaluate',

        computed: {
            stateText() {
                var state = {};
                this.stateType.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        data() {
            return {

                stateType: [{
                    name: '禁用',
                    value: 1
                },{
                    name: '启用',
                    value: 2
                }
                ]
            }
        },

        mounted() {
            this.$refs.search.search();


        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/orderEvaluate/list',
                    data
                });
            },

            disableActivity(item,state) {
                this.$confirm({
                    text: state == 2 ? '确定要启用此评价吗？' : '确定要禁用此评价吗',
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/updateState',
                            data: {
                                id: item.id,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 2 ? '启用成功' :'禁用成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            del(val) {
                this.$confirm({
                    text: '确定要删除此评价吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/remove',
                            data: {type:1,id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
        }
    }
</script>
